import submitSpinner from './epiforms__submit-spinner';
import addressesElementBlock from './addresses-element-block';

export default function exec () {
    submitSpinner();
	addressesElementBlock();
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/epiforms/index.js